import Permisos from '@/router/permisos'

const DefaultContainer = () => import('@/layouts/DefaultLayout.vue')
const ViewCampo = () => import('./Index')

const router = [
  {
    path: '/',
    component: DefaultContainer,
    children: [
      {
        path: 'campo',
        name: 'Campo',
        component: ViewCampo,
        beforeEnter: Permisos.IS_AUTENTICADO,
      },
    ],
  },
]

export default router
